import PropTypes from "prop-types";
import "../../../css/insert/category.css";
import "../../../css/common.css";
import { useEffect, useState } from "react";
import MobileHeader from "../../../component/MobileHeader";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Category({
    value,
    onChange,
    onPrev,
    onNext,
}) {
    const [evaluationList, setEvaluationList] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/evaluationList`)
            .then((res) => {
                setEvaluationList(Array.isArray(res.data) ? res.data : []);
            })
            .catch((err) => {
                console.error("evaluationList error:", err?.response?.status, err?.response?.data);
                setEvaluationList([]);
            });
    }, []);

    const handleNext = () => {
        if (!value || String(value).trim() === "") {
            alert("분류를 선택해주세요.");
            return;
        }
        onNext(value);
    };

    return (
        <div className="page">
            <div className="vr_mobile">
                <MobileHeader onPrev={() => navigate("/")} />
                <h1 className="title">분류</h1>
                <p className="sub_title">우수 및 불합리를 선택해주세요</p>

                {evaluationList.map((e) => {
                    const evlIdxStr = String(e.evlIdx);
                    const imgSrc =
                        e.evlIdx === 17
                            ? "/images/안전보건 가점활동.png"
                            : "/images/안전보건 감점활동.png";

                    return (
                        <div className="select_card_list" key={e.evlIdx}>
                            <label htmlFor={`evl-${e.evlIdx}`}>
                                <div className="badge">
                                    <img src={imgSrc} width="34" height="34" alt={e.evlNM} />
                                </div>

                                <div>
                                    <p>{e.evlIdx === 17 ? "안전보건 가점활동" : "안전보건 감점활동"}</p>
                                    <p>{e.evlIdx === 17 ? "(우수)" : "(불합리)"}</p>
                                </div>

                                <input
                                    id={`evl-${e.evlIdx}`}
                                    type="radio"
                                    name="evlIdx"
                                    value={evlIdxStr}
                                    checked={String(value) === evlIdxStr}
                                    onChange={(evt) => onChange(evt.target.value)}
                                />
                            </label>
                        </div>
                    );
                })}

                <div className="btn">
                    <button type="button" onClick={handleNext}>
                        <p>다음</p>
                    </button>
                </div>
            </div>
        </div>
    );
}

Category.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func.isRequired,
    onPrev: PropTypes.func,
    onNext: PropTypes.func.isRequired,
};